function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment } from "react";
import { Button } from "../Button/index.js";
import { Card as Root } from "../Card/index.js";
import { Icon } from "../Icon/index.js";
import { Typography } from "../Typography/index.js";
import { cn } from "../../common/helpers.js";
/**
 * Card Icon - [API](https://scl.sharp.com/?path=/docs/components-cardicon)
 *
 * @example
 *
 * <CardIcon
 *   heading="Coronado Hospital Foundation"
 *   description="Supports the health care needs"
 *   icon="mobile"
 *   button={{ label: 'Learn more' }}
 * />
 */ const CardIcon = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { icon, button, heading, description, slots = {}, slotProps = {}, className } = _param, props = _object_without_properties(_param, [
        "icon",
        "button",
        "heading",
        "description",
        "slots",
        "slotProps",
        "className"
    ]);
    var _slots_buttonContainer;
    const ButtonContainer = (_slots_buttonContainer = slots.buttonContainer) !== null && _slots_buttonContainer !== void 0 ? _slots_buttonContainer : slotProps.buttonContainer ? 'div' : Fragment;
    var _slots_button;
    const ButtonComponent = (_slots_button = slots.button) !== null && _slots_button !== void 0 ? _slots_button : Button;
    const buttonComponentProps = slots.button ? slotProps.button : _object_spread({
        width: 'full',
        size: 'sm'
    }, button, slotProps.button);
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread({
        ref: ref,
        variant: "filled",
        className: cn('flex', 'flex-col', 'gap-6', className)
    }, props), {
        children: [
            icon && /*#__PURE__*/ _jsx("div", {
                className: cn('flex', 'items-center', 'justify-center', 'bg-primary-50', 'h-[68px]', 'w-[68px]', 'rounded-full', '-mt-15'),
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: [
                        'fad',
                        icon
                    ],
                    className: "text-primary",
                    fontSize: 28
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "space-y-2 flex-grow",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h4",
                        as: "h3",
                        lineClamp: 2,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "div",
                        className: "scl-rich-text",
                        children: description
                    })
                ]
            }),
            (button || slots.button) && /*#__PURE__*/ _jsx(ButtonContainer, _object_spread_props(_object_spread({}, slotProps.buttonContainer), {
                children: /*#__PURE__*/ _jsx(ButtonComponent, _object_spread({}, buttonComponentProps))
            }))
        ]
    }));
});
export { CardIcon };
